import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

function Redirect() {
  const [status, setStatus] = useState('Đang chuyển hướng...');
  const hasTracked = useRef(false);  // THÊM flag để chỉ track 1 lần

  useEffect(() => {
    // Chỉ chạy 1 lần duy nhất
    if (hasTracked.current) return;
    hasTracked.current = true;

    const trackAndRedirect = async () => {
      try {
        const response = await axios.post(`${API_URL}/clicks/track`);
        
        setStatus(`Đang chuyển đến ${response.data.os === 'iOS' ? 'App Store' : 'CH Play'}...`);
        
        setTimeout(() => {
          window.location.href = response.data.redirectUrl;
        }, 1000);
      } catch (err) {
        console.error('Error tracking click:', err);
        setStatus('Có lỗi xảy ra. Vui lòng thử lại.');
      }
    };

    trackAndRedirect();
  }, []); // QUAN TRỌNG: dependency array rỗng

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      padding: '20px',
      textAlign: 'center'
    }}>
      <div style={{ marginBottom: '20px' }}>
        <svg 
          width="80" 
          height="80" 
          viewBox="0 0 100 100" 
          style={{ animation: 'spin 1s linear infinite' }}
        >
          <circle 
            cx="50" 
            cy="50" 
            r="40" 
            stroke="white" 
            strokeWidth="8" 
            fill="none" 
            strokeDasharray="180" 
            strokeLinecap="round"
          />
        </svg>
      </div>
      
      <h1 style={{ fontSize: '32px', marginBottom: '16px' }}>PharmaCom</h1>
      <p style={{ fontSize: '18px', opacity: 0.9 }}>{status}</p>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default Redirect;